(() => {
  const SELECTORS = {
    articleRoot: '[data-db-article]',
    contentRoot: '[data-article-content]',
    container: '.breed-faqs',
    item: '.faq-item',
    q: '.faq-q',
    a: '.faq-a',
  };

  const uniq = () => Math.random().toString(36).slice(2, 9);

  const setOpen = (item, open) => {
    if (!item) return;

    const btn = item.querySelector('.db-faq__q');
    const panel = item.querySelector('.db-faq__panel');
    if (!btn || !panel) return;

    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  };

  const closeSiblings = (container, except) => {
    const openItems = Array.from(container.querySelectorAll('.db-faq.is-open'));
    for (const it of openItems) {
      if (it === except) continue;
      setOpen(it, false);
    }
  };

  const enhanceItem = (item, prefix, index) => {
    if (!item || item.dataset.dbFaqEnhanced === '1') return;

    const qEl = item.querySelector(SELECTORS.q);
    // Answers can include multiple blocks (ex: 2+ <p class="faq-a"> paragraphs).
    // The old implementation only wrapped the first .faq-a, which caused any
    // additional paragraphs to "leak" outside the accordion.
    const aEls = Array.from(item.querySelectorAll(SELECTORS.a));
    if (!qEl || !aEls.length) return;

    item.dataset.dbFaqEnhanced = '1';
    item.classList.add('db-faq');

    const questionHTML = qEl.innerHTML;
    const questionText = (qEl.textContent || '').trim();

    const btnId = `db-faq-q-${prefix}-${index + 1}`;
    const panelId = `db-faq-a-${prefix}-${index + 1}`;

    // Build question button
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'db-faq__q';
    btn.id = btnId;
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', panelId);

    const textSpan = document.createElement('span');
    textSpan.className = 'db-faq__qText';
    // Preserve any markup inside the question (ex: <strong>)
    textSpan.innerHTML = questionHTML;

    const iconSpan = document.createElement('span');
    iconSpan.className = 'db-faq__icon';
    iconSpan.setAttribute('aria-hidden', 'true');

    btn.appendChild(textSpan);
    btn.appendChild(iconSpan);

    // Replace the <p class="faq-q"> with our button
    qEl.replaceWith(btn);

    // Wrap the answer in an animated panel
    const panel = document.createElement('div');
    panel.className = 'db-faq__panel';
    panel.id = panelId;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', btnId);
    panel.setAttribute('aria-hidden', 'true');

    const inner = document.createElement('div');
    inner.className = 'db-faq__panelInner';

    aEls.forEach((aEl) => {
      aEl.classList.add('db-faq__answer');
      inner.appendChild(aEl);
    });

    panel.appendChild(inner);

    btn.insertAdjacentElement('afterend', panel);

    if (questionText) {
      item.setAttribute('data-db-faq-label', questionText);
    }
  };

  const enhanceContainer = (container, idx) => {
    if (!container || container.dataset.dbFaqsEnhanced === '1') return;

    const items = Array.from(container.querySelectorAll(SELECTORS.item));
    if (!items.length) return;

    const prefix = `${idx}-${uniq()}`;

    // Upgrade items first
    items.forEach((item, i) => enhanceItem(item, prefix, i));

    // Apply enhanced styling class
    container.classList.add('db-faqs', 'db-faqs--enhanced');
    container.dataset.dbFaqsEnhanced = '1';

    // Start closed
    items.forEach((item) => setOpen(item, false));

    // Only one open at a time
    container.addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;

      const btn = t.closest('.db-faq__q');
      if (!btn) return;

      const item = btn.closest('.db-faq');
      if (!item) return;

      e.preventDefault();

      const isOpen = item.classList.contains('is-open');

      closeSiblings(container, item);
      setOpen(item, !isOpen);
    });
  };

  const run = () => {
    const articleRoot = document.querySelector(SELECTORS.articleRoot);
    if (!articleRoot) return;

    const contentRoot = articleRoot.querySelector(SELECTORS.contentRoot) || articleRoot;
    const containers = Array.from(contentRoot.querySelectorAll(SELECTORS.container));
    if (!containers.length) return;

    // Performance: FAQs are almost always below-the-fold.
    // Enhance only when the container is near the viewport to reduce initial main-thread work.
    if (!('IntersectionObserver' in window)) {
      containers.forEach((c, idx) => enhanceContainer(c, idx));
      return;
    }

    const idxMap = new WeakMap();
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          const container = entry.target;
          io.unobserve(container);

          const idx = idxMap.get(container) || 0;
          enhanceContainer(container, idx);
        }
      },
      { rootMargin: '200px 0px' }
    );

    containers.forEach((c, idx) => {
      idxMap.set(c, idx);
      io.observe(c);
    });
  };

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  } catch (err) {
    // Fail open: if anything goes wrong, leave the FAQs readable.
    // eslint-disable-next-line no-console
    console.error('[DB FAQ] Failed to initialize FAQ accordion', err);
  }
})();
